export const SITE = {
  brand: "drones3x.fr",
  phoneDisplay: "+33 6 66 96 15 35",
  phoneLink: "tel:+33666961535",
  emailDisplay: "ymrabet@drones3x.fr",
  emailLink: "mailto:ymrabet@drones3x.fr",
  brandDisplay: "drones3x.fr",
  address: "66 rue du Général de Gaulle, 95880 Enghien-les-Bains",
  addressMapsUrl: "https://www.google.com/maps/search/?api=1&query=66+rue+du+G%C3%A9n%C3%A9ral+de+Gaulle+95880+Enghien-les-Bains",
  contactPersonName: "Youness MRABET",
  contactPersonRole: "Fondateur · drones3x",
  contactPersonPhoto: "https://customer-assets.emergentagent.com/job_drones3x-vitrine/artifacts/o917p08o_younes.png",
  primaryYoutubeId: "1O0BxM9AtHY",
  weddingYoutubeId: "Bo0rIKtGPeg",
  cities: ["Paris", "Lyon", "Marseille", "Bordeaux", "Toulouse", "Nice", "Strasbourg", "Nantes", "Lille", "Cannes", "Monaco", "Genève"],
};

export const MEDIA = {
  hero: "https://static.prod-images.emergentagent.com/jobs/fb055db5-a39f-46ec-91f3-e3b3fdac1c45/images/76bcee067fe96be5efd4a7fc16867757384e0b76fd17c6c2bbb7eefb5fde34d2.png",
  wedding: "https://static.prod-images.emergentagent.com/jobs/fb055db5-a39f-46ec-91f3-e3b3fdac1c45/images/2460686f904b5e7d6e308d42c03e4a407bce6b981f8e2c4b894c468f32ec66fe.png",
  particles: "https://static.prod-images.emergentagent.com/jobs/fb055db5-a39f-46ec-91f3-e3b3fdac1c45/images/889262046447b09499f766181d4b24c9fb7d99545f5854dc6e764f5293fcf45f.png",
  corporate: "https://images.pexels.com/photos/35439843/pexels-photo-35439843.jpeg",
  festival: "https://images.pexels.com/photos/32399568/pexels-photo-32399568.jpeg",
  sport: "https://images.pexels.com/photos/7067934/pexels-photo-7067934.jpeg",
};
